const lettersList = 'abcdefghijklmnopqrstuvwxyz';

export function sortString(arr, attr) {
  let total = [];
  // 加多一步，数字等其他字符不参与排序
  const invalid = arr.filter(o => {
    return !/^[a-zA-Z\u4e00-\u9fa5]{1}/.test(o[attr]);
  })

  const chinese = arr.filter(o => {
    return /^[\u4e00-\u9fa5]{1}/.test(o[attr]);
  })
  const chineseArr = pySegSort(chinese, 'businessName');

  const english = arr.filter(o => {
    return /^[a-zA-Z]{1}/.test(o[attr]);
  })

  const englishArr = enSegSort(english, 'businessName');

  lettersList.split('').forEach(letter => {
    let cArr = chineseArr.filter(item => {
      return item.letter === letter;
    });
    if (cArr.length) {
      total = total.concat(cArr[0].data);
    }
    let eArr = englishArr.filter(item => {
      return item.letter === letter;
    });
    if (eArr.length) {
      total = total.concat(eArr[0].data);
    }
  })
  total = total.concat(invalid);
  return total;
}

function pySegSort(arr, attr) {
  if(!String.prototype.localeCompare) {
    return null;
  }
  const letters = "*abcdefghjklmnopqrstwxyz".split('');
  const zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split('');
   
  let segs = [];
  let curr;
  letters.forEach(function(v,i){
      curr = {letter: v, data:[]};
      arr.forEach(function(val) {
          if((!zh[i-1] || zh[i-1].localeCompare(val[attr],"zh") <= 0) && val[attr].localeCompare(zh[i],"zh") == -1) {
              curr.data.push(val);
          }
      });
      if(curr.data.length) {
          segs.push(curr);
          curr.data.sort(function(a,b){
              return a[attr].localeCompare(b[attr],"zh");
          });
      }
  });
  return segs;
}

function enSegSort(arr, attr) { 
  const letters = lettersList.split('');
  let segs = [];
  let curr;
  letters.forEach(function(v,i){
      curr = {letter: v, data:[]};
      arr.forEach(function(val, index) {
          if(val[attr][0].toLocaleLowerCase() === v.toLocaleLowerCase()) {
              curr.data.push(val);
          }
      });
      if(curr.data.length) {
          segs.push(curr);
      }
  });
  return segs;
}